var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBird2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 146,
    viewBox: "0 0 135 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59624 0C11.0927 3.53539 19.8252 5.89231 27.6137 10.3705C48.1469 22.3908 68.6801 34.6468 88.2693 48.317C97.9458 54.9164 102.902 65.0512 94.8776 77.5429C92.0455 82.0211 92.0455 88.6205 91.1015 94.2771C89.4494 102.291 92.5175 106.769 101.25 107.005C107.858 107.005 114.467 107.005 122.727 107.005C116.827 110.776 112.107 113.84 106.914 117.375C119.659 122.325 128.628 130.574 135 140.473C125.559 141.18 117.299 140.001 109.983 142.358C90.8654 148.722 72.6924 145.658 54.0472 141.416C44.8427 139.294 35.1661 138.116 25.7256 136.937C16.757 135.759 9.67666 132.224 2.59624 120.439C19.1172 119.496 32.57 118.789 48.1469 117.846C44.6067 94.5128 56.1713 69.2937 40.5944 47.1386C33.75 37.4752 22.8934 30.8757 14.6329 22.1551C9.20457 16.4985 4.95629 9.66339 0 3.29968C0.708042 2.12122 1.65218 1.17846 2.59624 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird2);
export default __webpack_public_path__ + "static/media/bird2.133fd068.svg";
export { ForwardRef as ReactComponent };